import { type Context } from '../ota-update-state-machine.types';

// ─── Delays ──────────────────────────────────────────────────────────────────

export const Delays = {
  POLLING_INTERVAL: ({ context }: { context: Context }) => context.options.pollingInterval,
};
